import { AppState } from '@context/type';
import { JourneyItemStateInterface } from '@context/reducers/journeys/journeys.type';

export function getJourney(
  state: AppState['journeys']['all'],
  id: string,
): JourneyItemStateInterface | null {
  return (
    state.data.filter((journey) => {
      return journey.id === id;
    })[0] || null
  );
}
